import { ButtonPosition } from '@/common/manager/position/button-position';
import { CnDialog } from '@cainiaofe/cn-ui';
export const config = {
    value: 'confirm',
    position: [ButtonPosition.tableBatchAreaAfterRequestSuccess],
    action: (config) => {
        const { response = {}, buttonConfig, state } = config || {};
        const msg = response?.msg;
        const { options = {} } = buttonConfig || {};
        const { type = 'success', title, content } = options;
        let realContent = content;
        if (typeof content === 'function') {
            realContent = content(response, state);
        }
        if (!realContent && !title) {
            realContent = msg;
        }
        CnDialog?.[type]?.({
            title,
            content: realContent,
        });
    },
};
